import { DEFAULT_UI_LOCALE, isUiLocale, type UiLocale } from "@/lib/i18n/languages";
import { marketingLocaleFromPath } from "@/lib/i18n/marketingLocale";

export function resolveUiLocale(input: {
  marketingLocale?: string | null;
  preferredLocale?: string | null;
  cookieLocale?: string | null;
}): UiLocale {
  if (isUiLocale(input.marketingLocale)) return input.marketingLocale;
  if (isUiLocale(input.preferredLocale)) return input.preferredLocale;
  if (isUiLocale(input.cookieLocale)) return input.cookieLocale;
  return DEFAULT_UI_LOCALE;
}

/**
 * Client navigations do not remount the root layout's I18nProvider.
 * Derive chrome locale from the URL: marketing prefixes win on public
 * pages; everywhere else the account/cookie preference wins.
 */
export function localeForPath(pathname: string, accountLocale: UiLocale): UiLocale {
  const marketing = marketingLocaleFromPath(pathname);
  if (isUiLocale(marketing)) return marketing;
  return isUiLocale(accountLocale) ? accountLocale : DEFAULT_UI_LOCALE;
}

/**
 * When the server-computed locale actually changes, follow it. When it has
 * not (the writer just used the in-app switcher), keep the in-memory value
 * until the next RSC payload arrives.
 */
export function localeAfterLayoutChange(
  previousInitial: UiLocale,
  nextInitial: UiLocale,
  current: UiLocale,
): UiLocale {
  if (previousInitial !== nextInitial) return nextInitial;
  return current;
}

/** Detected writing/browser language updates manuscript + AI, not app chrome. */
export function languageSuggestionUpdatesUiLocale(_language: string): boolean {
  return false;
}
